import { AxiosResponse } from 'axios';
import {
    Event,
    EventsSearchFilter,
    EventAPIType,
    EventPhotoSearchFilter,
    SimpleEvent,
    SimpleEventsSearchFilter,
    EventInfo,
    EventAlbumListItem,
    GetEventAlbumsListData,
    EventAlbumItem,
    GetEventsYearsListData,
    EventsYearsListItem
} from './types';
import {
    Page,
    PaginationResponse,
    PhotoPaginationResponse
} from 'src/api/base';
import httpClient from 'src/utils/http-сlient';
import queryString from 'query-string';
import { Photo } from 'src/api/photos/types';

const getEventsList = (
    page: Page,
    filter?: EventsSearchFilter
): Promise<AxiosResponse<PaginationResponse<Event>>> => {
    return httpClient.get<PaginationResponse<Event>>('/api/v2/events/', {
        params: {
            page: page.pageNumber,
            ...{ page_size: page.pageSize ? page.pageSize : 40 },
            ...(filter && { is_empty: filter.is_empty }),
            ...(filter?.location_id && { location_id: filter.location_id }),
            ...(filter?.year && { year: filter.year }),
            ...(filter?.file_id && { file_id: filter.file_id }),
            ...(filter?.search && { search: filter.search }),
            ...(filter?.event_id && { event_id: filter.event_id }),
            ...(filter?.person_id && { person_id: filter.person_id }),
            ...(filter?.photographer_id && {
                photographer_id: filter.photographer_id
            }),
            ...(filter?.date_after && { date_after: filter.date_after }),
            ...(filter?.date_before && { date_before: filter.date_before }),
            ...(filter?.file_id && { file_id: filter.file_id })
        },
        paramsSerializer(params) {
            return queryString.stringify(params, { arrayFormat: 'none' });
        }
    });
};

const getEventAlbumsList = (
    event_id: number,
    page: Page,
    data?: GetEventAlbumsListData
): Promise<AxiosResponse<PaginationResponse<EventAlbumListItem>>> => {
    return httpClient.get<PaginationResponse<EventAlbumListItem>>(
        `/api/v2/events/${event_id}/albums/`,
        {
            params: {
                page: page.pageNumber,
                ...{ page_size: page.pageSize ? page.pageSize : 40 },
                ...data
            }
        }
    );
};

const getEventAlbumsInfo = (
    event_id: number,
    album_id: number
): Promise<AxiosResponse<EventAlbumItem>> => {
    return httpClient.get<EventAlbumItem>(
        `/api/v2/events/${event_id}/albums/${album_id}/`
    );
};

const getEventEventsList = (
    event_pk: number,
    page: Page,
    data?: EventsSearchFilter
): Promise<AxiosResponse<PaginationResponse<Event>>> => {
    return httpClient.get<PaginationResponse<Event>>(
        `/api/v2/events/${event_pk}/events/`,
        {
            params: {
                page: page.pageNumber,
                ...{ page_size: page.pageSize ? page.pageSize : 40 },
                ...data
            }
        }
    );
};

const getEventEventsInfo = (
    event_pk: number,
    id: number
): Promise<AxiosResponse<EventInfo>> => {
    return httpClient.get<EventInfo>(`/api/v2/events/${event_pk}/events/${id}`);
};

const getEventInfo = (id: number): Promise<AxiosResponse<EventInfo>> => {
    return httpClient.get<EventInfo>(`/api/v2/events/${id}/`);
};

const getEventPhotosList = (
    id: number,
    page: Page,
    filter?: EventPhotoSearchFilter
): Promise<AxiosResponse<PhotoPaginationResponse<Photo>>> => {
    return httpClient.get<PhotoPaginationResponse<Photo>>(
        `/api/v2/events/${id}/photos/`,
        {
            params: {
                page: page.pageNumber,
                ...{ page_size: page.pageSize ? page.pageSize : 40 },
                ...filter
            },
            paramsSerializer(params) {
                return queryString.stringify(params, { arrayFormat: 'none' });
            }
        }
    );
};

const getSimpleEventsList = (
    page: Page,
    filter?: SimpleEventsSearchFilter
): Promise<AxiosResponse<PaginationResponse<SimpleEvent>>> => {
    return httpClient.get<PaginationResponse<SimpleEvent>>(
        `/api/v2/events/simple/`,
        {
            params: {
                page: page.pageNumber,
                ...{ page_size: page.pageSize ? page.pageSize : 40 },
                ...(filter?.location_id && { location_id: filter.location_id }),
                ...(filter?.year && { year: filter.year }),
                ...(filter?.search && { search: filter.search }),
                ...(filter?.person_id && { person_id: filter.person_id }),
                ...(filter?.photographer_id && {
                    photographer_id: filter.photographer_id
                }),
                ...(filter?.ordering && { ordering: filter.ordering }),
                ...(filter?.is_video && { is_video: filter.is_video })
            },
            paramsSerializer(params) {
                return queryString.stringify(params, { arrayFormat: 'none' });
            }
        }
    );
};

const getEventsYearsList = (
    page: Page,
    data?: GetEventsYearsListData
): Promise<AxiosResponse<PaginationResponse<EventsYearsListItem>>> => {
    return httpClient.get<PaginationResponse<EventsYearsListItem>>(
        '/api/v2/events/years/choices/',
        {
            params: {
                page: page.pageNumber,
                ...{ page_size: page.pageSize ? page.pageSize : 100 },
                ...data
            }
        }
    );
};

export default {
    getEventsList,
    getEventAlbumsList,
    getEventAlbumsInfo,
    getEventEventsList,
    getEventEventsInfo,
    getEventInfo,
    getEventPhotosList,
    getSimpleEventsList,
    getEventsYearsList
} as EventAPIType;
